<!--登录-->
<template>
	<div class="page-body center-wrap">
		<div class="form-div">
			<div class="title txt-24 txt-w7">{{ $t('谷丙转氨酶账户登录') }}</div>
			<div class="title2 txt-16 txt-w4">{{ $t('欢迎回来！使用您的电子邮件或电话号码登录') }}</div>
			<div class="tabs dis-fle txt-16">
				<!-- <span class="item">电话</span> -->
				<span class="item active">{{ $t('邮箱') }}</span>
			</div>

			<div class="form-item">
				<label class="label txt-20">{{ $t('邮箱') }}</label>
				<div class="value">
					<el-input v-model="account" :placeholder="$t('请输入账号')" size="medium" clearable></el-input>
				</div>
			</div>
			<div class="form-item">
				<label class="label txt-20">{{ $t('密码') }}</label>
				<div class="value">
					<el-input v-model="password" :placeholder="$t('请输入密码')" size="medium" type="password" clearable
						show-password></el-input>
				</div>
			</div>
			<div class="form-item">
				<el-checkbox v-model="checked">{{ $t('记住密码') }}</el-checkbox>
			</div>

			<div class="but" @click="login">{{ $t('登录') }}</div>

			<router-link to="/pc/register" class="qt txt-14 cur-poi">
				<span>{{ $t('注册') }}</span>
			</router-link>
			<router-link to="/pc/forgetPwd" class="qt txt-14 cur-poi">
				<span>{{ $t('忘记密码') }}</span>
			</router-link>
		</div>
	</div>
</template>
<script>
import {
	post
} from '@/http/request'

export default {
	components: {},
	data() {
		return {
			account: localStorage.getItem('account') || '',
			password: localStorage.getItem('password') || '',
			checked: !!localStorage.getItem('password'),
		};
	},
	mounted() {

	},
	beforeUnmount() { },
	methods: {
		login() {
			post(this.$apis.login, { account: this.account, password: this.password }).then(res => {
				if (res.code == 1) {
					if (this.checked == true) {
						localStorage.setItem('account', this.account)
						localStorage.setItem('password', this.password)
					} else {
						localStorage.setItem('account', '')
						localStorage.setItem('password', '')
					}
					this.$store.commit('setUserInfo', res.data.userinfo)
					this.$store.commit('setToken', res.data.userinfo.token)
					this.$notify.success(res.msg)
					// 延时跳转，让用户看到提示
					setTimeout(() => {
						this.$nav.go('/pc/home')
					}, 800)
					return
				}
			})
		}
	},
};
</script>
<style lang="scss" scoped>
@import "~@/style/pc/login.scss";
</style>